import { ExtraPageTitleContext } from '@app/providers/ExtraPageTitleProvider/ExtraPageTitleContext';
import { ExtraPageTitleProvider } from '@app/providers/ExtraPageTitleProvider/ExtraPageTitleProvider.main';

export { ExtraPageTitleContext, ExtraPageTitleProvider };
